<template>
  <div v-if="Display" class="edit-profile-page">
    <!-- Top Bar -->
    <div class="top-bar">
      <button class="icon-button" @click="handleBack">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7"/>
        </svg>
      </button>
      <h1 class="page-title">Edit profile</h1>
    </div>

    <!-- Content -->
    <div class="content">
      <!-- Profile Images Section -->
      <div class="profile-images-section">
        <div class="images-grid">
          <!-- Main Profile Image (Larger) -->
          <div class="main-image-wrapper">
            <div class="image-container main-image">
              <img :src="profileData.images[0] || defaultImage"/>
              <button class="edit-overlay" @click="selectImage(0)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                </svg>
                <span>Edit</span>
              </button>
              <div class="main-badge">Main</div>
            </div>
          </div>

          <!-- Additional Images (Smaller) -->
          <div class="additional-images">
            <div 
              v-for="index in 4" 
              :key="index"
              class="image-container small-image"
            >
              <img :src="profileData.images[index] || defaultImage" />
              <button class="edit-overlay small" @click="selectImage(index)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Profile Info Section -->
      <div class="profile-info-section">
        <!-- Pseudo -->
        <div class="info-item">
          <div class="info-header">
            <label>Pseudo</label>
            <button class="edit-button" @click="editField('pseudo')">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
            </button>
          </div>
          <p class="info-value" v-if="editingField !== 'pseudo'">{{ profileData.pseudo }}</p>
          
          <!-- Edit Form -->
          <div class="edit-form" v-if="editingField === 'pseudo'">
            <input 
              v-model="tempData.pseudo" 
              type="text" 
              class="form-input"
              placeholder="Enter your pseudo"
            />
            <button class="save-button" @click="saveField(this)">Save</button>
          </div>
        </div>

        <!-- Description -->
        <div class="info-item">
          <div class="info-header">
            <label>Description</label>
            <button class="edit-button" @click="editField('description')">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
            </button>
          </div>
          <p class="info-value" v-if="editingField !== 'description'">{{ profileData.description }}</p>
          
          <!-- Edit Form -->
          <div class="edit-form" v-if="editingField === 'description'">
            <textarea 
              v-model="tempData.description" 
              class="form-textarea"
              placeholder="Enter your description"
              rows="4"
            ></textarea>
            <button class="save-button" @click="saveField(this)">Save</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Hidden file input -->
    <input 
      ref="fileInput" 
      type="file" 
      accept="image/*" 
      style="display: none" 
      @change="(event)=>handleFileSelect(event,this)"
    />
    <AlertW type="error" ref="alertW"/>
    <Loader :loading="loading" />
  </div>
</template>

<script>
import Loader from "@/views/components/loader/Loader.vue"
import AlertW from "@/views/components/alertW/AlertW.vue"
import imageCompression from 'browser-image-compression'

export default {
  name: 'EditProfile',
  components: {
    Loader,
    AlertW
  },
  data() {
    return {
      Display:false,
      loading:false,
      profileData: {
        pseudo: '',
        description: '',
        images: [
          null,
          null,
          null,
          null,
          null
        ]
      },
      defaultImage: require('../img/profile.svg'),
      editingField: null,
      tempData: {},
      selectedImageIndex: null
    }
  },
  methods: {
    show () {
      this.Display = true
    },
    setImages (images,infos) {
      this.profileData.images = images
      this.profileData.pseudo = infos.pseudo
      this.profileData.description = infos.description
    },
    handleBack() {
      this.$emit('close');
      this.Display = false
      console.log('Back clicked');
    },
    editField(field) {
      this.editingField = field;
      this.tempData = { ...this.profileData };
    },
    async saveField(k) {
      if (k.editingField) {
        if(!k.validation(k.editingField,k.tempData[k.editingField])) return
        k.loading = true
        const result = await k.setText(k,k.editingField,k.tempData[k.editingField])
        k.loading = false
        if(!result) return
        k.$emit('updateText', {elt:k.editingField,val:k.tempData[k.editingField]});
        k.profileData[k.editingField] = k.tempData[k.editingField];
        k.editingField = null;
        k.tempData = {};
      }
    },
    selectImage(index) {
      this.selectedImageIndex = index;
      this.$refs.fileInput.click();
    },
    async handleFileSelect(event,k) {
      const file = event.target.files[0];
      if (file && k.selectedImageIndex !== null) {
        k.loading = true
        let result = await k.setProfileImages(k,k.selectedImageIndex+1,file)
        k.loading = false
        if(!result) return
        const reader = new FileReader();
        reader.onload = (e) => {
          k.profileData.images[k.selectedImageIndex] = e.target.result;
          k.$emit('updateImage',{image:e.target.result,index:k.selectedImageIndex})
        //  this.$emit('update', this.profileData);
        };
        reader.readAsDataURL(file);
      }
      // Reset file input
      event.target.value = '';
    },
    async setProfileImages(k,index,file) {
      let compressedCoverFile = file
      if(!(file.type === "image/svg+xml")) { // if it is not an svg
        const compressedCover = await imageCompression(file, {
          maxSizeMB: 1,
          maxWidthOrHeight: 800,
          useWebWorker: true,
          fileType: 'image/jpeg',
          initialQuality: 0.82
        })
        compressedCoverFile = new File(
          [compressedCover],
          file.name.replace(/\.[^.]+$/, '') + '.jpg',
          { type: 'image/jpeg' }
        )
      }
      const form = new FormData();
      form.append("type", "setProfileImages");
      form.append("indice", index);
      form.append("image", compressedCoverFile);

      try {
          const res = await k.$axios.post('user.php',
              form,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
          )
          console.log(res.data)
          //this.protectedData = res.data.data;
          return true
      } catch (e) {
        console.log(e)
        console.log(e.response?.data?.error || e.message)
        if(e.response?.data?.error == "Image exceeds 5MB limit") k.$refs.alertW.show("La taille de l'image ne peut depasser 5MO !")
        return false
      }
    },
    async setText(k,type,text) {
      try {
          let res
          if(type === "pseudo") res = await k.$axios.post('user.php',{type:"setPseudo",pseudo:text})
          else res = await k.$axios.post('user.php',{type:"setDescription",description:text})
          console.log(res.data)
          return true
      } catch (e) {
        console.log(e.response)
        console.log(e.response?.data?.error || e.message);
        if(e.response?.data?.error == "Pseudo already taken.") k.$refs.alertW.show("Le pseudo est deja utilise !")
        return false
      }
    },
    validation (type,val) {
      if(type === "pseudo") {
        if(!val || val.length <2 || val.length > 30) {
          this.$refs.alertW.show("Le format du pseudo est incorrect.")
          return false
        }
        return true
      }
      if(type === "description") {
        if(!val || val.length <5 || val.length > 400) {
          this.$refs.alertW.show("Le format de la description est incorrect.")
          return false
        }
        return true
      }
    }
  }
}
</script>

<style scoped>
.edit-profile-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #0a0e26;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  z-index: 1000;
  overflow-y: auto;
  padding-bottom: 120px;
}

.top-bar {
  position: sticky;
  top: 0;
  background: rgba(10, 14, 38, 0.95);
  border-bottom: 1px solid rgba(0, 212, 255, 0.1);
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  z-index: 100;
}

.icon-button {
  position: absolute;
  left: 20px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  color: #e0f7ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-button svg {
  width: 24px;
  height: 24px;
}

.icon-button:hover {
  background: rgba(0, 212, 255, 0.1);
  color: #00d4ff;
}

.page-title {
  color: #e0f7ff;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
  width: 100%;
  text-align: center;
}


.content {
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
}

.profile-images-section {
  margin-bottom: 40px;
}

.images-grid {
  display: flex;
  gap: 12px;
}

.main-image-wrapper {
  flex: 0 0 180px;
}

.additional-images {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.image-container {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background: rgba(30, 41, 59, 0.5);
  border: 2px solid rgba(0, 212, 255, 0.2);
  aspect-ratio: 1;
}

.main-image {
  height: 100%;
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.edit-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(10, 14, 38, 0.8);
  border: none;
  color: #00d4ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  opacity: 0;
  cursor: pointer;
}

.edit-overlay.small {
  font-size: 12px;
}

.edit-overlay svg {
  width: 24px;
  height: 24px;
}

.edit-overlay.small svg {
  width: 20px;
  height: 20px;
}

.image-container:hover .edit-overlay {
  opacity: 1;
}

.edit-overlay span {
  font-size: 14px;
  font-weight: 600;
}

.main-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  background: rgba(0, 212, 255, 0.9);
  color: #0a0e26;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.profile-info-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.info-item {
  background: rgba(30, 41, 59, 0.4);
  border: 1px solid rgba(0, 212, 255, 0.1);
  border-radius: 12px;
  padding: 16px;
}

.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.info-header label {
  color: #94a3b8;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.edit-button {
  background: transparent;
  border: none;
  color: #00d4ff;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-button svg {
  width: 18px;
  height: 18px;
}

.edit-button:hover {
  background: rgba(0, 212, 255, 0.1);
  transform: scale(1.1);
}

.info-value {
  color: #e0f7ff;
  font-size: 15px;
  margin: 0;
  white-space: pre-wrap;
}

.edit-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-input,
.form-textarea {
  background: rgba(10, 14, 38, 0.6);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 8px;
  padding: 12px;
  color: #e0f7ff;
  font-size: 15px;
  font-family: inherit;
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: #00d4ff;
  box-shadow: 0 0 0 3px rgba(0, 212, 255, 0.1);
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
}

.save-button {
  background: linear-gradient(135deg, #00d4ff, #0099cc);
  color: #ffffff;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.3);
}

.save-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 212, 255, 0.5);
}

@media (max-width: 480px) {
  .content {
    padding: 16px;
  }

  .main-image-wrapper {
    flex: 0 0 140px;
  }

  .images-grid {
    gap: 8px;
  }

  .additional-images {
    gap: 8px;
  }
}
</style>